import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";
import { useTranslation } from "react-i18next";

export default function SEO({ title, description, image, preloadImages = [] }) {
  const { i18n } = useTranslation();
  const location = useLocation();

  const { site, sanitySeo } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultTitle
          defaultDescription
          defaultImage
          siteUrl
          defaultIcon
        }
      }
      sanitySeo {
        title {
          en
          fr
        }
        description {
          en
          fr
        }
        image {
          asset {
            url
          }
        }
      }
    }
  `);

  const lang = i18n.language;
  console.log("sanitySeo", sanitySeo.description?.[lang]);

  const metaDescription =
    description ||
    sanitySeo?.description?.[lang] ||
    site.siteMetadata.defaultDescription;
  const metaTitle =
    title || sanitySeo?.title?.[lang] || site.siteMetadata.defaultTitle;
  const metaImage =
    image ||
    sanitySeo?.image?.asset?.url ||
    `${site.siteMetadata.siteUrl}${site.siteMetadata.defaultImage}`;
  const favicon = site.siteMetadata.defaultIcon;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="shortcut icon" href={favicon} />
      <link rel="icon" href={favicon} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/favicon_io/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon_io/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon_io/favicon-16x16.png"
      />
      <link rel="manifest" href="/favicon_io/site.webmanifest" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="image" content={metaImage} />
      <meta itemProp="image" content={metaImage} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={site.siteMetadata.siteUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <link
        rel="preload"
        href="/static/fonts/DINPro-Light/DINPro-Light.woff"
        as="font"
        type="woff"
        crossOrigin="anonymous"
      />

      {preloadImages &&
        preloadImages.map((image) => (
          <link rel="preload" href={image} as="image" key={image} />
        ))}

      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <link
        rel="canonical"
        href={`${site.siteMetadata.siteUrl}${location.pathname}`}
      />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: metaTitle,
          description: metaDescription,
          url: site.siteMetadata.siteUrl,
        })}
      </script>
    </Helmet>
  );
}
